const routes = {
	// ------------------------------
	// ENTITY / AGENCY
	// ------------------------------
	"entity-list": {
		admin: "/admin/entities",
		reseller: "/reseller",
		organization: "/organization",
	},

	"entity-detail": {
		admin: "/admin/entities/entity/:organizationId",
		reseller: "/reseller/:organizationId",
		organization: "/organization",
	},

	"entity-plan-detail": {
		admin: "/admin/entities/entity/:organizationId/plan/:planId",
		reseller: "/reseller/:organizationId/plan/:planId",
		organization: "/organization/plan/:planId",
	},

	"entity-plan-compile": {
		admin: "/admin/entities/entity/:organizationId/plan/:planId/compile",
		reseller: "/reseller/:organizationId/plan/:planId/compile",
		organization: "/organization/plan/:planId/compile",
	},

	// ------------------------------
	// AGENDAS (DIARY)
	// ------------------------------
	"agenda-list": {
		admin: "/admin/agendas",
		reseller: "/reseller/agendas",
		organization: "/organization/agendas",
	},

	"agenda-detail": {
		admin: "/admin/agendas/:organizationId/:agendaId",
		reseller: "/reseller/agendas/:organizationId/:agendaId",
		organization: "/organization/agendas/:agendaId",
	},

	// ------------------------------
	// PLAN TEMPLATES (SOLO ADMIN)
	// ------------------------------
	"plan-template-detail": {
		admin: "/admin/plans/template/detail/:templateId",
	},

	"plan-template-configuration": {
		admin: "/admin/plans/template/configuration/:templateId",
	},

	"plan-template-copy": {
		admin: "/admin/plans/template/copy/:organizationId/:templateId",
	},

	"plan-template-list": {
		admin: "/admin/plans",
	},
};

export const getRoutingPath = (route, role, params) => {
	const template = routes[route]?.[role];

	if (!template) {
		throw new Error(`Route not found for pathName "${route}" and role "${role}"`);
	}

	return template.replace(/:([A-Za-z0-9_]+)/g, (_, key) => {
		if (params[key] === undefined) {
			throw new Error(`Missing param "${key}" for route "${route}"`);
		}
		return params[key];
	});
};
